module.exports = "/resources/assets/prod/311350b7db71dd60461ce65d093a06ce.jpg";